export default {
  data: {
    $el: $('#lectures_json'),
    sessions: [],
    paginator: null,
    course_id: null
  },
  methods: {
    bindData: function (data) {
      this.paginator = data.paginator;
      this.sessions = data.lectures;
      this.course_id = data.course_id;
    },
    sessionListing: function (url_param, currentPage) {
      let self = this;

      //load the entries info from the server
      let page = $('.active.page').text().trim();
      let url = url_param ? url_param : Kadenze.Routes.course_sessions_path(self.course_id, {page: page});

      let request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done(function(data) {
        self.bindData(data);
      });

      request.fail(function(data) {
        console.warn('error retrieving session data');
        console.log(data);
        new Kadenze.Notice.error({ message: 'There was a problem loading sessions, please contact system administrators' });
      });

      request.always(function(xhr, textStatus) {
        Kadenze.PaginationBinding.applyBindingsWithTextInput(self.sessionListing);
      });
    },
    showDisabledModal(session) {
      if (session.modal) {
        new Kadenze.Notice.info(session.modal);
      } else {
        return true;
      }
    }
  },
  mounted: function () {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.sessionListing);
  }
};

